import React from "react";
import { EventType } from "pages/statuses/EventType";
import { DateUtil } from "utilities/DateUtil";

interface Props {
    // 予約情報
    booking: EventType;
}

/**
 * 予約時間表示コンポーネント
 * ダイアログのタイトルとして表示する予約時間を取得
 * @param props
 */
export const DisplayDate: React.FC<Props> = (props) => {
    const { booking } = props;

    return <span>{DateUtil.parseViewDateTime(booking.start, booking.end)}</span>;
};
